export function getRole(user) {
  if (!user) return null;

  let role = null;

  if (user.role) {
    role = user.role;
  } else if (user.seeker) {
    role = "SEEKER";
  } else if (user.provider) {
    role = "PROVIDER";
  } else {
    try {
      const localUser = JSON.parse(localStorage.getItem("user") || "{}");
      role = localUser.role || null;
    } catch (e) {
      // ignore
    }
  }

  if (typeof role === "string") {
    role = role.toUpperCase().trim();
    if (role === "SEEKER" || role === "PROVIDER") {
      return role;
    }
  }

  return null;
}
